/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ProfileViewStyles = makeStyles((theme: Theme) =>
	createStyles({
		profileButton: {
			padding: '5px 5px',
		},
		popover: {
			width: '300px',
		},
		container: {
			display: 'flex',
			justifyContent: 'flex-start',
		},
		imageContainer: {
			position: 'relative',
		},
		iconButton: {
			padding: 0,
			margin: '15px',
		},
		profileImage: {
			height: '50px',
			width: '50px',
			opacity: '75%',
			borderRadius: '50%',
		},
		profileImageIcon: {
			position: 'absolute',
			top: 'auto',
			bottom: 'auto',
		},
		username: {
			marginTop: 'auto',
			marginBottom: 'auto',
		},
		courseLeader: {
			color: theme.palette.grey['600'],
		},
		editNameButton: {
			height: '14px',
			width: '14px',
		},
		nameContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		buttonContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			margin: '0 auto',
		},
		logout: {
			color: theme.palette.error.light,
			marginBottom: '15px',
		},
		label: {
			justifyContent: 'flex-start',
			fontWeight: 'normal',
			fontSize: 'small',
		},
		textField: {
			width: '60%',
		},
		input: {
			fontSize: 'small',
		},
		submitButton: {
			width: '40%',
		},
	})
);

export default ProfileViewStyles;
